import { useCallback, useState } from 'react';
import { GeoDistance, GeoLocation } from 'modules/queryBuilder/types';
import { ConditionSingleValueGeolocationProps } from '../../types';

export const useGeoLocationHandlers = ({
  value: initialValue,
  onChange,
}: Pick<ConditionSingleValueGeolocationProps, 'value' | 'onChange'>) => {
  const [value, setValue] = useState<{ location: GeoLocation; distance: GeoDistance } | null>(
    initialValue,
  );

  const onGeoLocationChange = useCallback(
    (location: GeoLocation) => {
      if (!location) return;
      setValue((prev) => {
        if (!prev) return prev;
        const updatedValue = {
          ...prev,
          location: {
            ...prev.location,
            ...location,
          },
        };
        onChange(updatedValue);
        return updatedValue;
      });
    },
    [onChange],
  );

  const onGeoDistanceChange = useCallback(
    (distance: GeoDistance | null) => {
      if (!distance) return;
      setValue((prev) => {
        if (!prev) return prev;
        const updatedValue = {
          ...prev,
          distance: {
            ...prev.distance,
            ...distance,
          },
        };
        onChange(updatedValue);
        return updatedValue;
      });
    },
    [onChange],
  );

  return {
    value,
    onGeoDistanceChange,
    onGeoLocationChange,
  };
};
